import { combineReducers } from "redux";

import { reducer as form } from "redux-form";

import auth from "./_auth-reducer";

import locale from "./_locale-reducer";

import socialSignup from "./_social-signup-reducer";
import searchSettings from "./_search-settings-reducer";
import restaurants from "./_restaurants-reducer";
import order from "./_order-reducer";
import storage from "./_storage-reducer";
import groupOrder from "./_group-order-reducer";
import paying from "./_paying-reducer";
import friends from "./_friends-reducer";
import bannerRestaurants from "./_banner-restaurants-reducer";

 
import checkoutOrderModal from "./_checkout-order-modal-reducer";
 
export default combineReducers({
  form,
  auth,
  locale,
  friends,
  searchSettings,
  restaurants,
  socialSignup,
  order,
  storage,
  groupOrder,
  paying,
  checkoutOrderModal,
  bannerRestaurants,
});
